import { Arg, Entity, Field, Mutation } from '@adornis/baseql/decorators.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { BasicProduct } from '@adornis/payments/db/basic-product.js';

@Entity()
export class ILSProduct extends BasicProduct {
  public static override _class = 'ILSProduct';
  public static override _collectionName = 'products';

  @Field(type => String, { default: v => v ?? '' })
  override name!: string;

  @Field(type => Boolean, { default: v => v ?? false })
  public archived!: boolean;

  @Field(type => Boolean, { default: v => v ?? false })
  public published!: boolean;

  get price() {
    return this.prices?.[0]?.unitAmount ?? 0;
  }

  public override async remove() {
    if (this.published) throw new Error('remove(): Das Löschen von veröffentlichten ExamDays ist nicht möglich.');

    if (!(await (this.constructor as typeof ILSProduct).archiveILSProduct(this._id)()))
      throw new Error('ILSProduct.remove(): archiveILSProduct was not successful.');
    return true;
  }

  @Mutation(type => Boolean)
  private static archiveILSProduct(@Arg('examDayID', type => String) examDayID: string) {
    return async () => {
      const collection = await getCollection<ILSProduct>(this._class);
      const result = await collection.updateOne({ _id: examDayID }, { $set: { archived: true } });
      return result.matchedCount === 1;
    };
  }
}
